import { mapTypenameToAPIType } from "../mapTypenameToAPIType"

export function deleteProjectChildrenSerializer(
  data: { id: string; type: string }[],
  headers: Headers
) {
  headers.set("Content-Type", "application/json")
  return {
    body: JSON.stringify({
      data: {
        bulkAction: "delete",
        resources: data.map(resource => ({
          ...resource,
          type: mapTypenameToAPIType(resource.type)
        }))
      },
      jsonApi: { version: "1.0" }
    }),
    headers
  }
}
